import React, { FC } from 'react';

import { Model } from '../../index.model';

import { SelectInput } from 'views/components/select-input';

interface Props {
  model: Model;
  onUpdate: (model: Model) => void;
  inFocus: boolean;
}

const CategoryInput: FC<Props> = ({ model, onUpdate, inFocus }) => {

  const list = model.categories.documents.map(it => it.name);
  const index = model.categories.documents.findIndex(it => it.id === model.category?.id);

  function select(index: number) {
    onUpdate(model.change({ category: model.categories.documents[index] }));
  }

  return (
    <SelectInput list={list} index={index} onSelect={i => select(i)} readOnly={true} inFocus={inFocus}>
      <h2>Category</h2>
    </SelectInput>
  );

};

export { CategoryInput };